

















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import ConversationList from '@/components/Admin/MessageSystem/ConversationList.vue';
import Conversation from '@/components/Admin/MessageSystem/Conversation.vue';
import ConversationInfo from '@/components/Admin/MessageSystem/ConversationInfo.vue';
import AddConversationDialog from '@/components/Admin/MessageSystem/AddConversationDialog.vue';
import CreateTicketForm from '@/components/Admin/Forms/CreateTicketForm.vue';

@Component({
    components: {
        ConversationList,
        Conversation,
        ConversationInfo,
        AddConversationDialog,
        CreateTicketForm,
    },
    computed: {
        ...mapGetters({
            createTicketFormVisibility: 'Tickets/getTicketCreateFormVisibility',
        }),
    },
})
export default class MessageSystem extends Vue {
    constructor() {
        super();
    }
}
